import React, { useState, useRef, useEffect } from "react";
import reloadingArrow from "../assets/reloading-arrow.png";
import success from "../assets/success.mp3";
import close from "../assets/close.png";
import "./showStatistics.scss";

const ShowGameStatistics = (props) => {
  const whichPlayerTurn = props.settingProp;
  const boardData = props.boardData;
  let language = props.language;
  let activeSound = props.activeSound;
  let isVisible = props.isVisible;
  let setIsVisible = props.setIsVisible;
  const [player1Time, setPlayer1Time] = useState(0);
  const [player2Time, setPlayer2Time] = useState(0);
  const [audioPlayed, setAudioPlayed] = useState(false);
  const timerRef = useRef(null);

  const arr = [
    1, 3, 5, 7, 9, 10, 12, 14, 16, 18, 21, 23, 25, 27, 29, 30, 32, 34, 36, 38,
    41, 43, 45, 47, 49, 50, 52, 54, 56, 58, 61, 63, 65, 67, 69, 70, 72, 74, 76,
    78, 81, 83, 85, 87, 89, 90, 92, 94, 96, 98,
  ];

  let P1 = 0;
  let P2 = 0;

  for (let i = 0; i < arr.length; i++) {
    if (boardData[arr[i]][0] === 1 || boardData[arr[i]][0] === 31) {
      P1++;
    } else if (boardData[arr[i]][0] === 2 || boardData[arr[i]][0] === 32) {
      P2++;
    }
  }

  const toggleContainer = () => {
    setIsVisible(!isVisible);
  };
  useEffect(() => {
    if (whichPlayerTurn === 1) {
      timerRef.current = setInterval(() => {
        setPlayer1Time((prevTime) => prevTime + 1);
      }, 1000);
    } else if (whichPlayerTurn === 2) {
      timerRef.current = setInterval(() => {
        setPlayer2Time((prevTime) => prevTime + 1);
      }, 1000);
    }

    return () => {
      clearInterval(timerRef.current);
    };
  }, [whichPlayerTurn]);
  function formatTime(time) {
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = time % 60;

    return `${hours} : ${minutes} : ${seconds}`;
  }
  function replyGame() {
    window.location.reload();
  }
  const playAudio = (soundFile) => {
    if (activeSound && !audioPlayed) {
      const audio = new Audio(soundFile);
      audio.play();
      setAudioPlayed(true);
    }
  };
  function closeTheSettingTab() {
    setIsVisible(!isVisible);
  }
  return (
    <div className="container-right">
      <button onClick={toggleContainer}>{`${
        !isVisible
          ? language === "ar"
            ? "إظهار الاحصائيات"
            : "Show statistics"
          : language === "ar"
          ? "إخفاء الاحصائيات"
          : "Hide  statistics"
      }`}</button>
      {isVisible && (
        <div className="container-statistic">
          <img src={close} className="close-img" onClick={closeTheSettingTab} />

          <table
            style={{
              color: "white",
              border: "1px solid white",
              margin: "2em 0",
            }}
          >
            <tr>
              <th>
                <div className="red-square"></div>
              </th>
              <th>
                <div className="blue-square"></div>
              </th>
              <th></th>
            </tr>
            <tr>
              <td>{formatTime(player1Time)}</td>
              <td>{formatTime(player2Time)}</td>
              <td> {language === "ar" ? "توقيت اللاعب" : "player timing"}</td>
            </tr>
            <tr>
              <td>{P1}</td>
              <td>{P2}</td>
              <td>
                {language === "ar" ? "الوحدات المتبقية" : "remaining units"}
              </td>
            </tr>
            <tr>
              <td colSpan="2" style={{ textAlign: "center" }}>
                {" "}
                <div
                  className={` ${
                    whichPlayerTurn === 1 ? "red-square" : "blue-square"
                  }`}
                  style={{ display: "inline-block" }}
                  // style={{ textAlign: "center" }}
                ></div>
              </td>
              <td style={{ verticalAlign: "middle" }}>
                {" "}
                {language === "ar" ? "دور اللاعب" : "player turn"}
              </td>
            </tr>
          </table>
        </div>
      )}
      {P2 === 0 && (
        <div>
          <div className="centered-span-winner">
            <img
              src={reloadingArrow}
              className="rotate-on-hover-img"
              onClick={replyGame}
            />
            {language === "ar" ? (
              <>{playAudio(success)}! الفائز هو اللاعب الأول</>
            ) : (
              <>
                {playAudio(success)}
                The winner is the first player!
              </>
            )}
          </div>
        </div>
      )}
      {P1 === 0 && (
        <div>
          <div className="centered-span-winner">
            {language === "ar" ? (
              <>{playAudio(success)}! الفائز هو اللاعب الثاني</>
            ) : (
              <>
                {playAudio(success)}
                The winner is the second player!
              </>
            )}
            <img
              src={reloadingArrow}
              className="rotate-on-hover-img"
              onClick={replyGame}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ShowGameStatistics;
